/**
 * SD-2865: folding a live `action_card` chatStatus frame (SD-2798) into the
 * cards already held by the in-flight bubble.
 *
 * Pulled out of the chat component so the rules are testable on their own: the
 * component around them carries the store, effects and websocket graph, and none
 * of that is what these decisions depend on.
 *
 * @param existing cards already on the bubble, if any
 * @param cardJson the frame's raw card envelope
 * @returns the new card list, or null when there is nothing to change
 */
export function appendStreamedActionCard(
  existing: readonly string[] | undefined,
  cardJson: string | undefined | null
): string[] | null {
  const card = cardJson?.trim();
  if (!card) return null;

  const cards = existing ?? [];
  // A websocket reconnect replays frames for the turn still in flight, so the
  // same card can arrive twice. Rendering it twice is the failure this change
  // exists to prevent, so an identical envelope is a no-op.
  if (cards.includes(card)) return null;

  return [...cards, card];
}
